import { fromEntries } from '@/helpers/javascript'
import api from '@/api';

// initial state
const state = {
	bindings: {},
	rootBindingId: null
}

// getters
const getters = {
	bindingsEditMode (state) {
		return !!state.rootBindingId
	},

	newBinding (state) {
		return { path: 'tx', rootId: state.rootBindingId }
	}
}

// actions
const actions = {
	async fetchBindings ({ getters, commit }) {
		if (getters.bindingsEditMode) {
			commit('ADD_ERROR', { message: 'Попытка загрузить схему привязок в режиме редактирования' }, { root: true })
		} else {
			const response = await api.bindings.getBindings()
			commit('SET_BINDINGS', response.data)
			commit('UNSET_BINDINGS_ROOT_ID')
		}
	},

	async updateBinding ({ getters, commit }, binding) {
		if (getters.bindingsEditMode) {
			const response = await api.bindings.updateBinding(binding)
			commit('SET_BINDINGS', response.data)
		} else {
			commit('ADD_ERROR', { message: 'Попытка редактирования схемы привязок вне режиме редактирования' }, { root: true })
		}
	},

	async deleteBinding ({ getters, commit }, binding) {
		if (getters.bindingsEditMode) {
			const response = await api.bindings.deleteBinding(binding)
			commit('SET_BINDINGS', response.data)
		} else {
			commit('ADD_ERROR', { message: 'Попытка редактирования схемы привязок вне режиме редактирования' }, { root: true })
		}
	},

	async beginBindingTransaction ({ getters, commit }) {
		if (getters.bindingsEditMode) {
			commit('ADD_ERROR', {message: 'Попытка начала нового сеанса редактирования схемы привязок во время активного сеанса редактирования'}, {root: true})
		} else {
			const response = await api.bindings.beginBindingTransaction()
			commit('SET_BINDINGS', response.data)
			commit('SET_BINDINGS_ROOT_ID')
		}
	},

	async commitBindingTransaction ({ state, getters, commit }) {
		if (getters.bindingsEditMode) {
			const response = await api.bindings.commitBindingTransaction(state.rootBindingId)
			commit('SET_BINDINGS', response.data)
			commit('UNSET_BINDINGS_ROOT_ID')
		} else {
			commit('ADD_ERROR', { message: 'Попытка завершить несуществующий или уже завершённый сеанс редактирования схемы привязок' }, { root: true })
		}
	},

	async rollbackBindingTransaction ({ state, getters, commit }) {
		if (getters.bindingsEditMode) {
			const response = await api.bindings.rollbackBindingTransaction(state.rootBindingId)
			commit('SET_BINDINGS', response.data)
			commit('UNSET_BINDINGS_ROOT_ID')
		}
	}
}

// mutations
const mutations = {
	SET_BINDINGS (state, bindings) {
		state.bindings = fromEntries(bindings.map(b => [b.id, b]))
	},

	SET_BINDINGS_ROOT_ID (state) {
		state.rootBindingId = Object.values(state.bindings).map(b => b.rootId).filter(r => r)[0]
	},

	UNSET_BINDINGS_ROOT_ID (state) {
		state.rootBindingId = null
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
